import { useState, Suspense } from "react"
import MatchDetailsAudit from "./MatchDetailsAudit.jsx"
import { Tooltip } from 'react-tooltip'

export default function MatchDetailsStarted({groupId, match, bet}) {
  const [showGuesses, setShowGuesses] = useState(false)
  const toggleShowGuesses = () => {
    setShowGuesses(!showGuesses)
  }

  return (
    <>
      <div className="flex flex-col rounded-lg text-sm">
        <div className={`text-center space-x-2 bg-white border-green-500 text-green-500 px-2 border ${!showGuesses ? "rounded-b-lg" : ""} w-full`}>
          <span className="animate-pulse">⚽</span>
          <span id={`my-guess-${groupId}-${match.id}`} className="cursor-pointer text-center" onClick={() => toggleShowGuesses()}>
            Seu palpite: {bet.id !== null ? bet.guess_score_team_a : "-"} x {bet.id !== null ? bet.guess_score_team_b : "-"}
            <Tooltip anchorSelect={`#my-guess-${groupId}-${match.id}`} place="top" type="dark" effect="float">
              {`${showGuesses ? "Ocultar" : "Ver todos os"} palpites`}
            </Tooltip>
          </span>
        </div>
      </div>
      {showGuesses === true && (
        <div className="text-center w-full rounded-b-lg">
          <Suspense fallback={<p>Carregando...</p>}>
            <MatchDetailsAudit groupId={groupId} match={match} bet={bet} standingsAuditMatchPage={1} OnToggleShowGuessesClick={toggleShowGuesses}/>
          </Suspense>
        </div>
      )}
    </>
  )
}
